import { ToggleSwitch } from 'components/@common/ToggleSwitch'
import React from 'react'
import styled from 'styled-components'

const MarketingWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 1;
`

const InlineBlock = styled.div`
  display: inline-block;
`

const Label = styled.span`
  margin-left: 16px;
  font-size: 18px;
`

export const MarketingPreferencesRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: fit-content;
  margin: 0 auto;
`
export const MarketingPreferencesItem = ({
  id,
  label,
  optIn,
  onChange,
}: {
  id: string
  label: React.ReactNode
  optIn?: boolean | null
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}) => {
  return (
    <MarketingWrapper as='label'>
      <InlineBlock>
        <ToggleSwitch
          id={id}
          disabled={optIn === null}
          checked={optIn === true}
          onChange={onChange}
        />
      </InlineBlock>
      <Label>{label}</Label>
    </MarketingWrapper>
  )
}
